import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ParentsUIHelpers";

const ParentsUIContext = createContext();

export function useParentsUIContext() {
  return useContext(ParentsUIContext);
}

export const ParentsUIConsumer = ParentsUIContext.Consumer;

export function ParentsUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <ParentsUIContext.Provider value={value}>
      {children}
    </ParentsUIContext.Provider>
  );
}